import { create } from 'zustand';

export const useTitleStore = create<any>()((set) => ({
  hideTitle: true,
  setHideTitle: (boolean: boolean) => set(() => ({ hideTitle: boolean })),
}));
